import { render, staticRenderFns } from "./ProductVariantBox.vue?vue&type=template&id=016910eb&scoped=true&"
import script from "./ProductVariantBox.vue?vue&type=script&lang=ts&"
export * from "./ProductVariantBox.vue?vue&type=script&lang=ts&"
import style0 from "./ProductVariantBox.vue?vue&type=style&index=0&id=016910eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016910eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('016910eb')) {
      api.createRecord('016910eb', component.options)
    } else {
      api.reload('016910eb', component.options)
    }
    module.hot.accept("./ProductVariantBox.vue?vue&type=template&id=016910eb&scoped=true&", function () {
      api.rerender('016910eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/ProductVariantBox.vue"
export default component.exports